import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle, withState } from 'recompose'
import { Icon } from 'semantic-ui-react'
import ReactTable from 'react-table'

import { Cont } from './styled'
import { StdForm } from 'components'
import { fetchPermissions } from 'ducks/roleMan'
import { columns } from '../../AttributeData'

import FormPermissionModal from '../../FormPermissionModal'

let refTable = React.createRef()

const PermissionSection = props => {
  const {
    permissions,
    showModal,
    setShowModal,
    modalData,
    setModalData,
    modalTitle,
    setModalTitle,
    modalIsCreate,
    setModalIsCreate,
    defaultPage,
    setDefaultPage,
  } = props
  return (
    <Cont>
      <StdForm
        fitContent={false}
        title={
          <div>
            Permission
            <Icon
              link
              circular
              inverted
              color="teal"
              name="add"
              size="small"
              style={{ marginLeft: '1rem' }}
              onClick={() => showPermissionModal(true, null)}
            />
          </div>
        }
        style={{ width: '80vw' }}
        enableCollapse
      >
        <ReactTable
          ref={r => (refTable = r)}
          data={permissions && permissions}
          columns={columns.tPermission}
          defaultPageSize={10}
          previousText="previous"
          nextText="next"
          className="-striped -highlight"
          onPageChange={state => {props.setDefaultPage(state)}}
          page={defaultPage}
          getTdProps={(state, rowInfo, column, instance) => {
            return {
              onClick: (e, handleOriginal) => {
                if (rowInfo) {
                  showPermissionModal(false, rowInfo.original)
                }
              },
            }
          }}
        />
      </StdForm>
      {showModal.permission ? (
        <FormPermissionModal
          title={modalTitle}
          data={modalData}
          isCreate={modalIsCreate}
          show={showModal.permission}
          tablePageSize={refTable ? refTable.state.pageSize : 5}
          setCurrentPage={props.setDefaultPage}
          changeShow={() =>
            setShowModal({ ...showModal, permission: !showModal.permission })
          }
        />
      ) : null}
    </Cont>
  )

  function showPermissionModal(isCreate, data) {
    if (isCreate) {
      setModalIsCreate(true)
      setModalTitle('Create Permission')
      setModalData(null)
    } else {
      setModalIsCreate(false)
      setModalTitle('Update Permission')
      setModalData(data)
    }
    setShowModal({ ...showModal, permission: true })
  }
}

const mapStateToProps = state => ({
  permissions: state.roleMan.permissions,
})

const mapDispatchToProps = {
  fetchPermissions,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('showModal', 'setShowModal', {
    role: false,
    permission: false,
    permissionRole: false,
  }),
  withState('modalIsCreate', 'setModalIsCreate', false),
  withState('modalData', 'setModalData', null),
  withState('modalTitle', 'setModalTitle', ''),
  withState('roleId', 'setRoleId', 0),
  withState('defaultPage', 'setDefaultPage', 0),
  lifecycle({
    componentDidMount() {
      this.props.fetchPermissions()
    },
    componentWillReceiveProps(nextProp) {},
  })
)

export default enhance(PermissionSection)
